import Button from "@/components/button/Button"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Col, Row } from "antd"
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint"
import { FC } from "react"
import "./PaymentSuccess.less"

const { Title, Paragraph } = WebsiteTypography

const keyPoints = [
  {
    text: "A Proof of Payment (PoP) document has been generated by our system and is available for your review.",
  },
  {
    text: "There is no need to send the PoP document to the municipal company.",
  },
  {
    text: "As soon as you submit the application, the PoP document will be shared automatically.",
  },
]

const PaymentSuccess: FC = () => {
  const { xxl, xl, lg, md, sm } = useBreakpoint()
  const isMobileScr = !(xxl || xl || lg || md || sm)
  const { setIsModalDarkOpen } = useModalDarkContext()

  const handleClose = () => {
    setIsModalDarkOpen(false)
  }

  return (
    <Row justify={"center"} className={"payment-success-wrapper"} style={{ paddingBottom: 24 }}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        {!isMobileScr && (
          <Row justify={"center"} className={"payment-success-icon-wrapper"}>
            <div className={"payment-success-hex-wrapper"}>
              <SvgIcon type={"circled-tick"} />
            </div>
          </Row>
        )}

        <Title level={isMobileScr ? 5 : 3} centered className={"section-title"} style={{ paddingTop: 12 }}>
          <span className={"bold"}>{"Payment successful!"}</span>
        </Title>

        <Row justify={"center"} style={{ paddingTop: 4 }}>
          <Col span={24}>
            <Paragraph
              centered
              size={isMobileScr ? "sm" : "md"}
              color={"website-secondary"}
              weight={"w300"}
              style={{ paddingBottom: 24 }}
            >
              {"Your application fee has been processed successfully."}
            </Paragraph>
          </Col>
        </Row>

        <Row justify={"center"} className={"divider-with-hex"} style={{ margin: "16px 0 24px 0" }}>
          <div className={"hex-small"} />
        </Row>

        <Row gutter={[0, 16]} style={{ paddingBottom: 8 }}>
          {keyPoints.map((point, idx) => (
            <Col key={idx} span={24}>
              <Row align={"middle"} wrap={false} gutter={[12, 0]} className={"payment-success-key-point"}>
                <div className={"payment-success-bullet"}>
                  <SvgIcon type={"orange-circles"} />
                </div>
                <Paragraph size={isMobileScr ? "xs" : "sm"} color={"website-secondary"} weight={"w300"}>
                  {point.text}
                </Paragraph>
              </Row>
            </Col>
          ))}
        </Row>
      </Col>

      <Row justify={"center"} className={"divider-with-hex"} style={{ margin: "16px 0 24px 0" }}>
        <div className={"hex-small"} />
      </Row>

      <Row justify={"center"} style={{ paddingTop: 8 }}>
        <Col span={isMobileScr ? 24 : 12}>
          <Button btnType={"primary"} text={"Okay"} onClick={handleClose} block size={"large"} />
        </Col>
      </Row>
    </Row>
  )
}

export default PaymentSuccess
